import React from 'react';
import { IconProps } from './types/Icon.type';

function PaginationRightIcon(props: IconProps) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.14645 4.64645C7.34171 4.45118 7.65829 4.45118 7.85355 4.64645L12.8536 9.64645C13.0488 9.84171 13.0488 10.1583 12.8536 10.3536L7.85355 15.3536C7.65829 15.5488 7.34171 15.5488 7.14645 15.3536C6.95118 15.1583 6.95118 14.8417 7.14645 14.6464L11.7929 10L7.14645 5.35355C6.95118 5.15829 6.95118 4.84171 7.14645 4.64645Z"
        fill={props.fill ?? '#121212'}
      />
    </svg>
  );
}

export default PaginationRightIcon;
